/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from "@material-tailwind/react";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import CardComp from "../../components/others/CardComp";
import PieChart from "../../components/others/PieChart";
import { getAuthData } from "../../features/auth/authSlice";
import { getDashboardData } from "../../features/dashboard/dashboard";
import HomeLayout from "../../layouts/Home";
import config from "../../utils/config";
import { JobsColorData } from "../../utils/fakeData";
import { AppType, getAmount } from "../../utils/helper";

const BankDash = () => {
  const { stats, loading } = useSelector(getDashboardData),
    { preloading } = useSelector(getAuthData);

  // totalAwaitingManualAssignment
  const totalJobs = useMemo(() => {
    if ("totalJobs" in stats) {
      const unwantedJobsTotal = stats?.totalAwaitingManualAssignment;
      return stats?.totalJobs - unwantedJobsTotal;
    }
  }, [loading, stats]);

  const data = useMemo(() => {
    const result = [
      {
        title: "Total Registered Vendors",
        amount: getAmount(
          config.appType === AppType.cav
            ? stats?.totalRegisteredVendors || 0
            : stats.totalRegisteredSolicitors || 0
        ),
        rate: "32",
        id: 1,
      },
      {
        title: "Total Awaiting Vendors Assignment",
        amount: getAmount(stats?.totalVendorsAwaitingAssignment || 0),
        rate: "35",
        id: 2,
      },
      {
        title: "Total Jobs",
        amount: totalJobs || 0,
        rate: "40",
        id: 3,
      },
      {
        title: "Total Count Of Paid Jobs",
        amount: getAmount(stats?.totalCountOfPaidJobs || 0),
        rate: "34",
        id: 4,
      },
      {
        title: "Total Jobs Awaiting Payment",
        amount: getAmount(stats?.totalJobsAwaitingPayment || 0),
        rate: "38",
        id: 5,
      },
      {
        title: "Total Jobs Awaiting Branch Confirmation",
        amount: getAmount(stats?.totalJobsAwaitingBranchConfirmation || 0),
        rate: "33",
        id: 6,
      },
      {
        title: "Total Pending Jobs",
        amount: getAmount(stats?.totalPendingJobs || 0),
        rate: "35",
        id: 7,
      },
      {
        title: "Total Jobs Pending Acknowledgement",
        amount: getAmount(stats?.totalPendingAcknowledgement || 0),
        rate: "39",
        id: 8,
      },
    ];
    // if (AppType.cs === appType) delete result[result.length - 2]; // Total Jobs Awaiting Branch Confirmation
    return result;
  }, [loading, stats, preloading]);

  const JobsChartData = useMemo(() => {
    return [
      {
        value: stats?.totalClosedJobs || 0,
        name: loading ? "..." : `${stats?.totalClosedJobs || 0} Closed Jobs`,
      },
      {
        value: stats?.totalRejectedJobs || 0,
        name: loading
          ? "..."
          : `${stats?.totalRejectedJobs || 0} Rejected Jobs`,
      },
    ];
  }, [loading, stats, preloading]);

  return (
    <HomeLayout handleSearch>
      <div className="  mb-8">
        <Typography className="text-[24px] font-[500]">Dashboard</Typography>
        <Typography className="text-[18px] font-[400]">Overview</Typography>
      </div>
      <div className="mb-8">
        <div className="md:grid lg:grid-cols-3 md:grid-cols-2 gap-6">
          {data.map((data) =>
            data.id === 3 ? (
              <div className="lg:my-0 my-6 row-span-2 lg:w-ful xl:h-full h-[220px] xl:my-0 px-5 py-4 bg-white rounded-[22px] border border-[#EFF0F6]">
                <h2 className="text-[17px] font-[600] tracking-[0.18px]">
                  Total Jobs
                </h2>
                <h5 className="text-[22px] font-[700] mt-3">
                  {loading ? "..." : getAmount(totalJobs || 0)}
                </h5>
                <div className="w-full">
                  <PieChart
                    id="bankDash"
                    data={JobsChartData}
                    color={JobsColorData}
                    pieChartClass="w-[430px] h-[120px]"
                  />
                </div>
              </div>
            ) : (
              <CardComp
                loading={loading}
                title={data.title}
                amount={data.amount}
                key={data.id}
                rate={data.rate}
              />
            )
          )}
        </div>
      </div>
    </HomeLayout>
  );
};

export default BankDash;
